import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ImportInfoScreenImageDesktop } from '../../../assets/imgs/import-info-screen-desktop.svg';
import { ReactComponent as ImportInfoScreenImageMobile } from '../../../assets/imgs/import-info-screen-mobile.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/new/export.svg';
import { Button, EButtonType, KitIcons } from '@repo/apg-ui';

interface Props {
  onClose: () => void;
}

export const InfoPopup = ({ onClose }: Props) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 767);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 767) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <React.Fragment>
      <div className={'info-popup'} id={'importInfoModal'}>
        <div onClick={onClose} className='close-icon'>
          <KitIcons.CloseIcon />
        </div>
        {isMobile ? (
          <div>
            <ImportInfoScreenImageMobile />
            <div className='help-text-1 font-12 fw-bold d-flex flex-row align-items-center'>
              <div className='rounded-number me-3'>1</div>
              <div>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage1'}
                  defaultMessage={'Belassen Sie es bei einer einzigen Spalte.'}
                />
              </div>
            </div>
            <div className='help-text-2 font-12 fw-bold d-flex flex-row align-items-center'>
              <div className='rounded-number me-3'>2</div>
              <div>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage2'}
                  defaultMessage={'Es ist in Ordnung, eine Spalte zu benennen.'}
                />
              </div>
            </div>
            <div className='help-text-3 font-12 fw-bold d-flex flex-row align-items-start'>
              <div className='rounded-number'>3</div>
              <div className={'ms-3'}>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage3'}
                  defaultMessage={
                    "Geben Sie die Produkt-ID's nacheinander in getrennten Zeilen an. Die Produkt-ID's sollten nur Zahlen sein."
                  }
                />
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className='d-flex flex-row'>
              <div className='help-text-1 font-12 fw-bold'>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage1'}
                  defaultMessage={'Belassen Sie es bei einer einzigen Spalte.'}
                />
              </div>
              <div className='help-text-2 font-12 fw-bold'>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage2'}
                  defaultMessage={'Es ist in Ordnung, eine Spalte zu benennen.'}
                />
              </div>
              <div className='help-text-3 font-12 fw-bold'>
                <FormattedMessage
                  id={'ec.modals.import.infoMessage3'}
                  defaultMessage={
                    "Geben Sie die Produkt-ID's nacheinander in getrennten Zeilen an. Die Produkt-ID's sollten nur Zahlen sein."
                  }
                />
              </div>
              <div className='d-flex flex-column'></div>
              <ImportInfoScreenImageDesktop />
            </div>
          </div>
        )}
        <Button
          buttonType={EButtonType.BasicLink}
          isSvgStroke={true}
          isSvgFill={false}
          className={'d-flex mb-48 align-items-center flex-row justify-content-center'}
          href={
            'https://apgwebsite2021privatecloud-live-e989965-f00c998.divio-media.org/filer_public/e7/8c/e78cc6ff-8b81-439d-b78f-a8e5910bde8e/example_csv.csv'
          }
        >
          <div className='text-underline font-bold'>
            <FormattedMessage
              id='ec.modals.import.infoMessage.downloadExample'
              defaultMessage='Download Beispiel.csv'
            />
          </div>
          <DownloadIcon className={'me-3 info-icon'} />
        </Button>
      </div>
    </React.Fragment>
  );
};
